/* Example name attribute for file inputs: name="file[Attachment]"

  <input type="file" name="file[Attachment]" multiple />
  <input type="file" name="file[FileUploads]" />

  document.addEventListener('FileUpload', e => { 
    console.log(e.detail)
    let { start, end, form, urls } = e.detail
    if (start) {
      console.log('Starting to upload...')
    } else {
      console.log('Done uploading! These are the urls:', urls)
    }
  })
*/

;(_ => {
  let DEBUG = false 
  const noop = () => {}
  const loggersFns = {
    log: window.console.log.bind(window),
    warn: window.console.warn.bind(window),
    error: window.console.error.bind(window),
  }
  const console = new Proxy(loggersFns, {
    get: function (target, prop, receiver) {
      return DEBUG ? target[prop] : noop
    },
  })
  
  async function asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index)
    }
  }
  // -----------------------------------

  let ORIGINAL_SA = window.ShopifyAnalytics
  let SA_ID = null
  let _fetch = window.fetch;
  let _validateFile = () => true

  function disableAnalytics() {
    clearTimeout(SA_ID)
    window.ShopifyAnalytics = null
    console.log('ShopifyAnalytics - Disabled')
  }
  function enableAnalytics() {
    SA_ID = setTimeout(_ => {
      window.ShopifyAnalytics = ORIGINAL_SA
      console.log('ShopifyAnalytics - Enabled')
    }, 200)
  }

  // Multiple files will be joined by:
  let TEMP_ITEM_KEY = '__temp_item'
  let COL_HANDLE = window.ContactForm_CollectionHandle || 'all'

  // Variant will be fetch only once, then cached
  // Any variant will work! Even out of stock
  let VARIANT = null
  let retryCount = 0
  async function getValidVariant() {
    if (VARIANT) return VARIANT

    retryCount++
    if (retryCount > 3) {
      throw new Error('Unable to find variant')
    }

    const variant = await _fetch(`/collections/${COL_HANDLE}/products.json?limit=1`)
      .then(r => r.json())
      .then(d => d.products)
      .then(prods => prods[0].variants[0])

    if (!variant) {
      return getValidVariant()
    }

    VARIANT = variant

    return variant
  }

  function objectToFormData(obj) {
    let fd = new FormData()
    Object.keys(obj).forEach(key => {
      let value = obj[key]
      if (value != null) {
        fd.append(key, value)
      }
    })
    return fd
  }

  function getUploadedUrlsFromCartItem(item) {
    let props = item.properties || {}
    return Object.keys(props).reduce((acc, key) => {
      const value = props[key]
      if (key !== TEMP_ITEM_KEY && value.startsWith('https://')) {
        acc.push(value)
      }
      return acc
    }, [])
  }

  async function addToCart(obj) {
    disableAnalytics()
    return _fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      body: objectToFormData(obj),
    })
      .then(r => {
        console.log(r.ok ? 'Successfully added the product to cart' : 'Error adding to cart')
        return r.json()
      })
      .catch(e => {
        console.warn('Oops - caught error while adding to cart. ', e.message)
      })
      .finally(enableAnalytics)
  }

  async function removeFromCart(id) {
    return _fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        accept: 'application/json',
      },
      body: JSON.stringify({ updates: { [id]: 0 } }),
    })
      .then(r => r.json())
      .then(c => {
        console.log('Removed temporary product from cart', id)
        return c
      })
  }

  /* Example name attribute for file inputs: name="file[Attachment]" */
  const FILE_NAME_REGEX = /^file\[[\w\d-_]\]$/

  const extractFileInputName = inputField => {
    let attr = inputField.dataset.actualFileAttr
    if (attr) return attr

    let name = inputField.name
    if (!name) return null

    attr = ((name.match(/^file\[([\w\d-_\s]+)\]$/) || [])[1] || '').trim()
    if (attr) {
      inputField.dataset.actualFileAttr = attr
    }
    return attr || null
  }

  function addHidden(form, name, value) {
    // Create a hidden input element, and append it to the form:
    let nameAttrEscaped = name.replace(/[\[\]\s]/g, '\\$&')
    let input = form.querySelector(`[name=${nameAttrEscaped}]`)

    if (!input) {
      input = document.createElement('input')
      input.type = 'hidden'
      // input.name = name
      input.setAttribute('data-name', name)
      input.setAttribute('data-hidden-file-input', '')
      form.appendChild(input)
    }

    return input
  }

  async function uploadFiles(obj) {
    let variant = await getValidVariant()
    let data = {
      form_type: 'product',
      utf8: 'âœ“',
      id: variant.id,
      quantity: 1,
    }

    data[`properties[${TEMP_ITEM_KEY}]`] = 'Temporary item ' + +Date.now()

    Object.keys(obj).forEach(k => {
      const file = obj[k]
      data[`properties[${k}]`] = file
    })

    let addedItem = await addToCart(data)
    console.log('Added Item', addedItem)

    let urls = getUploadedUrlsFromCartItem(addedItem)
    removeFromCart(addedItem.key)

    return urls
  }

  async function handleFileChange(elements, ev) {
    const target = ev.target
    const fileAttrName = extractFileInputName(target)
    if (!fileAttrName) return

    console.log('File input changed event', ev)

    const files = Array.from(target.files)
    
    let validationErr = null
    await asyncForEach(files, async file => {
      if (validationErr) return
	  const isValidFile = await _validateFile(file)
      if (isValidFile === true || isValidFile == null) return
      if (isValidFile === false || typeof isValidFile === 'string') {
		validationErr = isValidFile || 'File validation failed'
	  }
    })

    if (validationErr) {
      target.value = null
      return
    }

    // No files selected
    if (!files.length) {
      console.log('No files to upload.. Clearing fields')

      target._associatedActualInput.value = ''
      target._associatedActualInput.name = ''
      return
    }

    console.log('Uploading files..', files)

    document.dispatchEvent(
      new CustomEvent('FileUpload', {
        detail: { form: elements.form, input: target, submitBtn: elements.submitBtn, files: files, start: true, end: false },
      })
    )

    target.disabled = true;
    if (elements.submitBtn) {
      elements.submitBtn.disabled = true
    }

    // There are some files! Lets upload them
    const variant = await getValidVariant()

    // Accumulate files to make formdata
    const filesToUpload = files.reduce((acc, file, i) => {
      let thisfileAttrName = fileAttrName
      if (i > 0) thisfileAttrName += `-${i}`

      acc[thisfileAttrName] = file
      return acc
    }, {})

    let uploadedUrls = null
    let errored = true
    try {
      uploadedUrls = await uploadFiles(filesToUpload)
      errored = false

      if (uploadedUrls.length) {
        target._associatedActualInput.value =
          uploadedUrls.length === 1
            ? uploadedUrls[0]
            : uploadedUrls.map((url, i) => `${i + 1} - ${url}`).join('\n')
        target._associatedActualInput.name = target._associatedActualInput.dataset.name
      }
    } catch(e) {
      errored = e
      throw e
    } finally {
      target.disabled = false;
      if (elements.submitBtn) {
        elements.submitBtn.disabled = false
      }
     document.dispatchEvent(
        new CustomEvent('FileUpload', {
          detail: { form: elements.form, input: target, submitBtn: elements.submitBtn, urls: uploadedUrls, start: false, end: true, error: errored },
        })
      )
    }
  }

  function fileUploadableForm(form) {
    if (form._handlesUpload) return
    form._handlesUpload = true

    let submitBtn = form.querySelector('[type="submit"]')
    let fileInputs = Array.from(form.querySelectorAll('[name^="file\\["]')).filter(input =>
      extractFileInputName(input)
    )

    fileInputs.forEach(fileInput => {
      fileInput.disabled = false;
      fileInput.removeAttribute('disabled');

      let attr = extractFileInputName(fileInput)
      let associatedActualInput = addHidden(form, `contact[${attr}]`)
      fileInput._associatedActualInput = associatedActualInput
    })

    const elements = { form: form, submitBtn: submitBtn, fileInputs: fileInputs }
    console.log('Contact form detected elements: ', elements)

    form.addEventListener('change', handleFileChange.bind(this, elements))
  }

  // -----------------------------------

  function init(form, opts) {
    if (!form || !form.nodeName === 'FORM') {
      return Promise.reject(new Error('Missing form'))
    }

    // Cache variant first
    if (opts) {
      if (opts.fetch) {
        _fetch = opts.fetch
      }
      if (opts.validate) {
        _validateFile = opts.validate
      }
    }
    getValidVariant().then(_ => {
      fileUploadableForm(form)
    })
  }

  window.shopifyUploadableForm = init
})()

/*

shopifyUploadableForm.initializeForm(form, {
  beforeUpload: ({ files }) => undefined,
  validate: () => true || throw,
})
*/
